export default __webpack_public_path__ + "static/media/jobPost.968d542b.svg";